module.exports = __webpack_public_path__ + "img/no_avatar.6f6bbb16.png";